import { Injectable } from '@angular/core';

import { GraphEndpoint, HandleSimpleRequest, TaBaseService } from '@ta/server';
import { isNonNullable } from '@ta/utils';
import { filter, map, mergeMap } from 'rxjs';
import { createTenantLink, deleteTenantLink, updateTenant } from './mutation';
import { UpdateTenantInput } from './form/dto/updateTenantInput';
import { UserProfile, userProfileProps } from './dto/user';
import { tenantProps } from './dto/tenant';
import { userInfoQuery } from './queries';

const graphEndpoint: GraphEndpoint = {
  clientName: 'tenantService',
  endpoint: '',
};

@Injectable({
  providedIn: 'root',
})
export class TenantService extends TaBaseService {
  /** Le dossier locataire tel que le serveur le donne ; les écritures le font relire. */
  public tenantDetail = new HandleSimpleRequest<UserProfile>();

  constructor() {
    super();
    super.registerRoutes({ graphEndpoint: graphEndpoint });
  }

  public fetchTenantDetails$() {
    return this.tenantDetail.fetch(
      this._graphService.fetchQueryBuilder<UserProfile>(
        userInfoQuery({
          props: `
            ${userProfileProps.get('id')}
            ${userProfileProps.get('bailoId')}
            ${userProfileProps.get('firstname')}
            ${userProfileProps.get('lastname')}
            ${userProfileProps.get('email')}
            ${userProfileProps.get('picture')}
            ${userProfileProps.get('dateOfBirth')}
            ${userProfileProps.get('tenant')} {
              ${tenantProps.get('id')}
              ${tenantProps.get('animals')}
              ${tenantProps.get('cpas')}
              ${tenantProps.get('description')}
              ${tenantProps.get('fieldVisibilities')} { fieldName isPublic }
              ${tenantProps.get('insurance')}
              ${tenantProps.get('revenue')}
              ${tenantProps.get('smoking')}
              ${tenantProps.get('vehicle')}
            }
          `,
        }),
        graphEndpoint.clientName,
      ),
    );
  }

  public updateTenant$(tenant: Partial<UpdateTenantInput>) {
    return this._graphService
      .mutate(updateTenant(tenant), 'updateTenant', graphEndpoint.clientName, ['userInfo'])
      .pipe(
        filter(isNonNullable),
        mergeMap((result) => this.fetchTenantDetails$().pipe(map(() => result))),
      );
  }

  public createTenantLink$() {
    return this._graphService
      .mutate<UserProfile>(createTenantLink(), 'createTenantLink', graphEndpoint.clientName, [
        'userInfo',
      ])
      .pipe(
        filter(isNonNullable),
        mergeMap((result) => this.fetchTenantDetails$().pipe(map(() => result))),
      );
  }

  public deleteTenantLink$() {
    return this._graphService
      .mutate<unknown>(deleteTenantLink(), 'deleteTenantLink', graphEndpoint.clientName, [
        'userInfo',
      ])
      .pipe(
        filter(isNonNullable),
        mergeMap((result) => this.fetchTenantDetails$().pipe(map(() => result))),
      );
  }
}
